// import gui from './gui';
import TweenMaxLine  from 'TimelineLite';
import CustomEase from './CustomEase';

let tlIntro, tlGame, tlProduct, tlProductHover;

const animation = {
    intro: () => {
        if (tlIntro) {
            tlIntro.kill();
            tlIntro = null;
        }

        tlIntro = new TweenMaxLine({
            delay: 0,
            repeat: 0,
            paused: false
        });

        const el0 = document.querySelectorAll('[data-animation="intro-0"]');
        const el1 = document.querySelectorAll('[data-animation="intro-1"]');
        const el2 = document.querySelectorAll('[data-animation="intro-2"]');
        const el3 = document.querySelectorAll('[data-animation="intro-3"]');
        const all = [el0, el1, el2, el3];

        const tl = tlIntro;

        if (all.some(el => !el.length)) {
            return;
        }

        tl.set(all, {opacity: 0, y: '20px'});
        tl.set(el0, {opacity: 0, y: 0});

        tl.to(el0, 0.2, {opacity: 1});
        tl.to(el1, 0.5, {opacity: 1, y: 0}, 'step-1+=1.2');
        tl.to(el2, 0.5, {opacity: 1, y: 0}, 'step-1+=1.4');
        tl.to(el3, 0.5, {opacity: 1, y: 0}, 'step-1+=1.6');
    },
    game: () => {
        if (tlGame) {
            tlGame.kill();
            tlGame = null;
        }

        tlGame = new TweenMaxLine({
            delay: 0,
            repeat: 0,
            paused: false
        });

        const el0 = document.querySelectorAll('[data-animation="game-0"]');
        const elD1 = document.querySelectorAll('[data-animation="game-decor-1"]');
        const elD2 = document.querySelectorAll('[data-animation="game-decor-2"]');

        const all = [el0, elD1, elD2];
        const tl = tlGame;

        if (all.some(el => !el.length)) {
            return;
        }

        [...el0].forEach((el, i) => {
            const max = el0.length;
            const y = Math.round((max - i) * 50) + 'px';
            tl.set(el, {opacity: 0, y});
        });

        tl.set(elD1, {y: '150px'}, 'start');
        tl.set(elD2, {y: '350px', opacity: 0}, 'start');
        tl.addLabel('step-1', 'start+=0.2');

        tl.staggerTo(el0, 1.5, {opacity: 1, y: 0, ease: window.Power2.easeOut}, 0.3, 'step-1');
        tl.to(elD1, 1.5, {y: 0, ease: window.Power2.easeOut}, 'step-1+=0.2');
        tl.to(elD2, 1.6, {y: 0, opacity: 1, ease: window.Power2.easeOut}, 'step-1+=0.25');
    },
    product: () => {
        if (tlProduct) {
            tlProduct.kill();
            tlProduct = null;
        }

        tlProduct = new TweenMaxLine({
            delay: 0,
            repeat: 0,
            paused: false
        });

        const el0 = document.querySelectorAll('[data-animation="product-0"]');
        const el1 = document.querySelectorAll('[data-animation="product-1"]');
        const el2 = document.querySelectorAll('[data-animation="product-2"]');
        const el3 = document.querySelectorAll('[data-animation="product-3"]');

        const elD1 = document.querySelectorAll('[data-animation="product-decor-1"]');
        const elP1 = document.querySelectorAll('[data-animation="product-pic-1"]');
        const elP2 = document.querySelectorAll('[data-animation="product-pic-2"]');
        const elP3 = document.querySelectorAll('[data-animation="product-pic-3"]');
        const elP4 = document.querySelectorAll('[data-animation="product-pic-4"]');
        const elP5 = document.querySelectorAll('[data-animation="product-pic-5"]');

        const elT1 = document.querySelectorAll('[data-animation="product-text-1"]');
        const elT2 = document.querySelectorAll('[data-animation="product-text-2"]');

        const all = [el0, el1, el2, el3, elD1, elP1, elP2, elP3, elP4, elP5, elT1, elT2];
        const tl = tlProduct;

        if (all.some(el => !el.length)) {
            return;
        }

        tl.set([elT1, elT2], {opacity: 0, y: '20px'});
        tl.set([el0, el1, el2, el3], {scale: 0}, 'start');
        tl.set(elD1, {scale: 0.8, transformOrigin: '50% 100%'}, 'start');
        tl.set(elP1, {y: '20px', scale: 0.9}, 'start');
        tl.set(elP2, {y: '-10%', x: '80%', scale: 0.75}, 'start');
        tl.set(elP3, {y: '0%', x: '-70%', rotation: 17, scale: 0.75}, 'start');
        tl.set(elP4, {y: '-30%', x: '70%', rotation: 4, scale: 0.75}, 'start');
        tl.set(elP5, {y: '-20%', x: '70%', rotation: 8, scale: 0.75}, 'start');
        tl.addLabel('step-1', 'start+=0.4');


        const ease0 = CustomEase.create('custom', 'M0,0 C0.111,0.085 0.224,1.259 0.418,1.259 0.521,1.259 0.548,1 0.548,1 0.548,1 0.598,1.087 0.665,1.085 0.726,1.084 0.774,1.004 0.774,1.004 0.774,1.004 0.84,1.048 0.886,1.044 0.948,1.039 1,1 1,1');

        const ease5 = CustomEase.create('custom', 'M0,0 C0.084,0.859 0.045,1.485 0.238,1.485 0.388,1.485 0.452,1 0.452,1 0.452,1 0.496,1.087 0.612,1.085 0.696,1.084 0.75,1 0.75,1 0.75,1 0.82,1.027 0.891,1.024 0.953,1.02 1,1 1,1');

        const timescale = 1.6;

        tl.to(el3, 0.25 * timescale, {scale: 1.1, ease: ease0}, 'step-1');
        tl.to(el2, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1');
        tl.to(el1, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1+=0.12');
        tl.to(el0, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1+=0.04');


        tl.to(elD1, 0.5 * timescale, {scale: 1, ease: window.Elastic.easeOut.config(1, 0.3)}, 'step-1+=0.07');
        tl.to(elP1, 0.7 * timescale, {y: 0, scale: 1, ease: window.Elastic.easeOut.config(1, 0.2)}, 'step-1');
        
        
        tl.to(elP2, 0.5, {y: '0%', x: '0%', scale: 1, ease: window.Elastic.easeOut.config(1, 0.5)}, 'step-1');
        tl.to(elP3, 0.55, {y: '0%', x: '0%', rotation: 0, scale: 1, ease: window.Elastic.easeOut.config(1, 0.5)}, 'step-1');
        tl.to(elP4, 1, {y: '0%', x: '0%', rotation: 0, scale: 1, ease:window.Elastic.easeOut.config(1, 0.5)}, 'step-1+=0.1');
        tl.to(elP5, 1, {y: '0%', x: '0%', rotation: 0, scale: 1, ease:window.Elastic.easeOut.config(1, 0.5)}, 'step-1');

        tl.to(elT1, 0.5, {opacity: 1, y: 0}, 'step-1+=0.5');
        tl.to(elT2, 0.5, {opacity: 1, y: 0}, 'step-1+=0.7');
    },
    productHover: () => {
        if (tlProductHover) {
            tlProductHover.kill();
            tlProductHover = null;
        }

        tlProductHover = new TweenMaxLine({
            delay: 0,
            repeat: 0,
            paused: false
        });

        const el0 = document.querySelectorAll('[data-animation="product-0"]');
        const el1 = document.querySelectorAll('[data-animation="product-1"]');
        const el2 = document.querySelectorAll('[data-animation="product-2"]');
        const el3 = document.querySelectorAll('[data-animation="product-3"]');

        const elD1 = document.querySelectorAll('[data-animation="product-decor-1"]');
        const elP1 = document.querySelectorAll('[data-animation="product-pic-1"]');
        const elP2 = document.querySelectorAll('[data-animation="product-pic-2"]');
        const elP3 = document.querySelectorAll('[data-animation="product-pic-3"]');
        const elP4 = document.querySelectorAll('[data-animation="product-pic-4"]');
        const elP5 = document.querySelectorAll('[data-animation="product-pic-5"]');

        const elT1 = document.querySelectorAll('[data-animation="product-text-1"]');
        const elT2 = document.querySelectorAll('[data-animation="product-text-2"]');

        const all = [el0, el1, el2, el3, elD1, elP1, elP2, elP3, elP4, elP5, elT1, elT2];
        const tl = tlProductHover;

        if (all.some(el => !el.length)) {
            return;
        }

        const resetTime = 0.1;

        tl.to([el0, el1, el2, el3], resetTime,  {scale: 0}, 'start');
        tl.to(elD1, resetTime, {scale: 0.8, transformOrigin: '50% 100%'}, 'start');
        tl.to(elP1, resetTime, {y: '20px', scale: 0.9}, 'start');
        tl.to(elP2,  resetTime, {y: '-10%', x: '80%', scale: 0.75}, 'start');
        tl.to(elP3, resetTime, {y: '0%', x: '-70%', rotation: 17, scale: 0.75}, 'start');
        tl.to(elP4, resetTime,  {y: '-30%', x: '70%', rotation: 4, scale: 0.75}, 'start');
        tl.to(elP5, resetTime, {y: '-20%', x: '70%', rotation: 8, scale: 0.75}, 'start');
        tl.addLabel('step-1', 'start+=0.1');

        const ease0 = CustomEase.create('custom', 'M0,0 C0.111,0.085 0.224,1.259 0.418,1.259 0.521,1.259 0.548,1 0.548,1 0.548,1 0.598,1.087 0.665,1.085 0.726,1.084 0.774,1.004 0.774,1.004 0.774,1.004 0.84,1.048 0.886,1.044 0.948,1.039 1,1 1,1');

        const ease5 = CustomEase.create('custom', 'M0,0 C0.084,0.859 0.045,1.485 0.238,1.485 0.388,1.485 0.452,1 0.452,1 0.452,1 0.496,1.087 0.612,1.085 0.696,1.084 0.75,1 0.75,1 0.75,1 0.82,1.027 0.891,1.024 0.953,1.02 1,1 1,1');

        const timescale = 1.6;

        tl.to(el3, 0.25 * timescale, {scale: 1.1, ease: ease0}, 'step-1');
        tl.to(el2, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1');
        tl.to(el1, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1+=0.12');
        tl.to(el0, 0.4 * timescale, {scale: 1, ease: ease5}, 'step-1+=0.04');

        tl.to(elD1, 0.5 * timescale, {scale: 1, ease: window.Elastic.easeOut.config(1, 0.3)}, 'step-1+=0.07');
        tl.to(elP1, 0.7 * timescale, {y: 0, scale: 1, ease: window.Elastic.easeOut.config(1, 0.2)}, 'step-1');
        
        tl.to(elP2, 0.5, {y: '0%', x: '0%', scale: 1, ease: window.Elastic.easeOut.config(1, 0.5)}, 'step-1');
        tl.to(elP3, 0.55, {y: '0%', x: '0%', rotation: 0, scale: 1, ease: window.Elastic.easeOut.config(1, 0.5)}, 'step-1');
        tl.to(elP4, 1, {y: '0%', x: '0%', rotation: 0, scale: 1, ease:window.Elastic.easeOut.config(1, 0.5)}, 'step-1+=0.1');
        tl.to(elP5, 1, {y: '0%', x: '0%', rotation: 0, scale: 1, ease:window.Elastic.easeOut.config(1, 0.5)}, 'step-1');
    }
};


// gui.add(animation, 'product');
// gui.add(animation, 'productHover');
// gui.domElement.parentElement.style.zIndex = 9999;


export default animation;


// WEBPACK FOOTER //
// ./js/animations.js